<template>
	<div class="line">
		<div ref="linechart" class="linechart" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false">
		</div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope62',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '控制折线图-scope62',
			timer: null,
			defaultdata: [
				{ value1: '1月', value2: '80', value3: '系列一', value4: '60', value5: '系列二' },
				{ value1: '2月', value2: '40', value3: '系列一', value4: '40', value5: '系列二' },
				{ value1: '3月', value2: '62', value3: '系列一', value4: '70', value5: '系列二' },
				{ value1: '4月', value2: '90', value3: '系列一', value4: '20', value5: '系列二' },
				{ value1: '5月', value2: '88', value3: '系列一', value4: '36', value5: '系列二' },
				{ value1: '6月', value2: '75', value3: '系列一', value4: '52', value5: '系列二' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '折线图数值1', key: "value2" },
				{ name: '折线图图例1', key: 'value3' },
				{ name: '折线图数值2', key: "value4" },
				{ name: '折线图图例2', key: 'value5' },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
			autoTimePaused: false,
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.linechart);
			let data1 = [];
			let data2 = [];
			let legend = [];
			this.defaultdata.forEach((item, i) => {
				if (item.value2 && item.value3) {
					const vdata1 = { name: item.value3, value: item.value2 };
					data1.push(vdata1);
				}
				if (item.value4 && item.value5) {
					const vdata2 = { name: item.value5, value: item.value4 };
					data2.push(vdata2);
				}
				if (i == 0) {
					if (item.value3) {
						legend.push({
							top: "2%",
							right: "50%",
							itemHeight: 12, //图例的高度  文字左边那个
							itemWidth: 10,
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value3, icon: "rect" }],
						});
					}
					if (item.value5) {
						legend.push({
							top: "2%",
							left: "50%",
							itemHeight: 12, //图例的高度  文字左边那个
							itemWidth: 10,
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value5, icon: "rect" }],
						});
					}
				}
			});
			const xAxis = this.defaultdata.map((item) => item.value1);
			const percent = (6 / xAxis.length) * 100;
			var Toption = {
				title: [
					{
						text: '单位:%',
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: xAxis.length > 6 ? '40px' : "10px",
					top: "40px",
					containLabel: true,
				},

				legend: [...legend],
				xAxis: {
					type: "category",
					axisTick: {
						show: false,
					},
					boundaryGap: false,
					axisLabel: {
						interval: xAxis.length > 12 ? 0 : xAxis.length > 9 ? 1 : 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
						formatter: function (value) {
							return value
						},
					},
					axisPointer: {
						type: "shadow",
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
					data: this.defaultdata.map((item) => item.value1),
				},
				yAxis: {
					type: "value",
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
						},
						fontSize: 14,
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				dataZoom: xAxis.length > 6 ? [
					{
						id: "dataZoom2", // 唯一的id
						type: "slider", // 这里可以选择你需要的dataZoom类型
						realtime: true,
						backgroundColor: "#031438",
						dataBackground: {
							lineStyle: {
								color: "#0182fc",
								width: 2,
								opacity: 1,
							},
							areaStyle: {
								color: {
									type: "linear",
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [
										// 渐变颜色
										{
											offset: 0,
											color: "#0182fc",
										},
										{
											offset: 1,
											color: "rgba(35,216,234,0.00)",
										},
									],
									// global: false,
								},
								opacity: 0.5,
							},
						},
						textStyle: {
							show: false,
							color: "#bdc2cb",
						},
						start: 0,
						end: percent,
						borderColor: "transparent", //边框背景颜色，与背景色相同来假装背景色
						handleStyle: {
							//两侧缩放手柄的样式配置。
							borderWidth: 1, //描边线宽。为 0 时无描边。
							color: "#00b7fe",
						},
						handleLabel: {
							show: false,
						},
						filterMode: "empty", // 设置过滤模式为 'empty'，表示只对当前 dataZoom 组件对应的 series 进行缩放
						seriesIndex: 0,
					},
					{
						type: "inside",
						realtime: true,
						start: 30,
						end: 70,
						filterMode: "empty",
						seriesIndex: 1,
					},
				] : [],
				series: [
					{
						name: this.defaultdata[0].value3 || "",
						type: "line",
						// smooth: 0.5,
						showSymbol: true,
						symbol: "circle",
						symbolSize: 8,
						symbolOffset: [0, "8%"],
						// label: {
						//   show: true,
						//   position: 'top',
						//   textStyle: {
						//     //设置文本样式
						//     color: "#3880F3",
						//   },
						//   formatter: '{c} %'
						// },
						lineStyle: {
							color: "#3880F3",
							width: 2,
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#0182fc", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#0182fc", // 0% 处的颜色
										},
									],
									false
								),
							},
						},
						data: data1,
					},
					{
						name: this.defaultdata[0].value5 || "",
						type: "line",
						// smooth: true,//线条原画
						// symbol: 'none',//线条点击
						// smooth: 0.5,
						showSymbol: true,
						symbol: "circle",
						symbolSize: 8,
						symbolOffset: [0, "8%"],
						//   show: true,
						//   position: 'top',
						//   textStyle: {
						//     //设置文本样式
						//     color: "#6FF2FA",
						//   },
						//   formatter: '{c} %'
						// },
						lineStyle: {
							color: "#04eaea",
							width: 2,
						},
						itemStyle: {
							normal: {
								color: "#05ffff", // 0% 处的颜色
							},
						},
						data: data2,
					},
				],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.linechart {
	width: 100%;
	height: 100%;
}
</style>